import PropTypes from 'prop-types';
import { BandwidthIcon, ConnectionErrorIcon, CPUIcon, DotIcon } from '../../Icons';

const HEALTH_ICON = {
  dot: DotIcon,
  cpu: CPUIcon,
  connectionError: ConnectionErrorIcon,
  bandwidth: BandwidthIcon,
};

/*
#tailwind
*/

function HealthIndicatorIcon({ icon }) {
  const Icon = HEALTH_ICON[icon];
  return <Icon />;
}

HealthIndicatorIcon.propTypes = {
  icon: PropTypes.oneOf(['dot', 'cpu', 'connectionError', 'bandwidth', 'warning']),
};

HealthIndicatorIcon.defaultProps = {
  icon: 'dot',
};

export default HealthIndicatorIcon;
